import { ReactNode } from 'react';

type IfProps = {
    children: ReactNode;
    condition: unknown;
};

export const If = ({ children, condition }: IfProps) => (condition ? children : null);
